import api from "./api";

const exchangeService = {
  getDetailsByToken: (jwttoken, activeTokenId) =>
    api.get("/exchange-details/" + activeTokenId, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  getOrders: (jwttoken) =>
    api.get("/exchange-order/myorder", {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  getOrdersByActive: (jwttoken, activeId) =>
    api.get("/exchange-order/myorder/" + activeId, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  getAllOrders: (jwttoken, activeId) =>
    api.get(`/exchange-order/all/${activeId}`, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  cancelOrder: (jwttoken, orderId) =>
    api.delete("/exchange-order/" + orderId, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  cancelOrderBinance: (jwttoken, orderId) =>
    api.delete("/exchange-order/delete-binance/" + orderId, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
};

export default exchangeService;
